import { Box } from "@mui/material";
import { BulkAssignGoalTemplateStatus } from "apps/web/src/views/GoalConfigurationTemplates/BulkAssignGoalTemplateStatus";
import { GoalConfigurationTemplateContent } from "apps/web/src/views/GoalConfigurationTemplates/GoalConfigurationTemplateContent";
import { GoalConfigurationTemplateProvider } from "apps/web/src/views/GoalConfigurationTemplates/GoalConfigurationTemplateProvider";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom-v5-compat";

const TEMPLATES = "Organization Templates";
const JOB_STATUS = "Assignment Status";
const tabs = [TEMPLATES, JOB_STATUS];

// This helps redirect from the assignment to the status tab without having to go through the router
const getTabFromSearchParams = (searchParams: URLSearchParams) => searchParams.get("tab") === "jobs" ? JOB_STATUS : TEMPLATES;

export const GoalsTemplatePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromSearchParams = getTabFromSearchParams(searchParams);
  const [selectedTab, setSelectedTab] = useState(tabFromSearchParams);
  useEffect(() => {
    if (searchParams.get("tab") === "assignment-status") {
      if (selectedTab !== JOB_STATUS) {
        setSelectedTab(JOB_STATUS);
      }
      setSearchParams({});
    }
  }, [searchParams]);

  return (
    <Box sx={{ display: "flex", height: "100%", flex: 1 }}>
      {selectedTab === TEMPLATES && (
        <GoalConfigurationTemplateProvider>
          <GoalConfigurationTemplateContent tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
        </GoalConfigurationTemplateProvider>
      )}
      {selectedTab === JOB_STATUS && (
        <BulkAssignGoalTemplateStatus tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} />
      )}
  </Box>
  );
};
